export default function EmailUnread() {
  return (
    <div
      className="ion-icon-email-unread"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<circle cx="432" cy="160" r="64"/>
	<g>
		<path d="M225,160H33.799c-11.1,0-13.898,3-11.299,10.5c1.5,4.4,8.4,8.1,12.5,10.2c11,5.8,163.799,89.1,169.5,92.1
			c5.699,3,11.5,4.4,20.5,4.4s14.799-1.4,20.5-4.4c3.79-1.995,72.625-39.497,121.559-66.107C357.594,193.551,352,177.433,352,160
			H225z"/>
		<path d="M293.199,273.3l82.201,92.5c2,2,2.898,4.4,1.799,5.601c-1.199,1.1-3.799,0.5-5.9-1.4l-98.6-83.2
			c-14.9,9.601-25.4,16.2-27.199,17.2c-7.701,3.9-13.1,4.4-20.5,4.4s-12.801-0.5-20.5-4.4c-1.9-1-12.301-7.6-27.201-17.2l-98.6,83.2
			c-2,2-4.699,2.6-5.9,1.4C71.6,370.3,72.5,367.8,74.5,365.8l82.1-92.5C107.9,241.8,33.5,189.4,25.299,185.2
			C16.5,180.7,16,186,16,190.1c0,4.101,0,205,0,205C16,404.4,29.699,416,39.5,416H225h185.5c9.799,0,21.5-11.7,21.5-20.9
			c0,0,0-94.398,0-155.1c-21.726,0-41.416-8.673-55.832-22.729C350.167,235.173,318.36,257.025,293.199,273.3z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
